"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai-assist.suggestions.header': 'Sugestie AI',
    'ai-assist.suggestions.close': 'Zamknij',
    'ai-assist.suggestions.intro': 'Wybierz sugestię, aby zastosować ją do swojego zapytania:',
};
